export default __webpack_public_path__ + "static/media/17.e5a66639.jpg";